import { OptionItem } from '../models/option-item';

/**
 * Produtos disponíveis para consulta. Lista mantida no frontend
 * (não há endpoint correspondente).
 */
export const PLANOS: readonly OptionItem[] = [
  { id: '22', label: 'PLANO CD 2 ELETROPAULO' },
  { id: '23', label: 'PLANO CD CPFL' },
  { id: '26', label: 'ISA ENERGIA BRASIL PREV' },
  { id: '33', label: 'CESP CD' },
];
